<template>

  <div class="file-upload-list-item">

		<div class="file-upload-list-item-name col-lg-8 col-xl-8 col-12">
			<i class="fa fa-paperclip mr-2" aria-hidden="true"></i> {{ file.name }}
		</div>

		<div class="file-upload-list-item-size col-lg-3 col-xl-3 col-12">
			{{ file.size }}
		</div>

		<div class="file-upload-list-item-buttons col d-flex">
			<button type="button" class="btn-text btn-text--primary" @click="$emit('remove')">
				<i class="fa fa-trash fa-lg"></i>
			</button>
		</div>

  </div>

  <!-- <div class="file-upload-single-item">
    <div class="file-upload-single-item-name">
      <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
      {{ file.name }}
    </div>
    <button type="button" class="btn-text btn-text--primary" @click="$emit('remove')">
      {{ $t('fileUpload.delete') }}
    </button>
  </div> -->
</template>

<script>
  export default {
    name: 'vuestic-file-upload-single-item',
    props: {
      file: {
        type: Object
      }
    },
  }
</script>

<style lang='scss'>
  .file-upload-single-item {
    display: flex;
    &-name {
      margin-right: 1rem;
    }
  }

  .file-upload-list-item {
    & + & {
      margin-top: 0.5rem;
    }
    min-height: 2.7rem;
    display: flex;
    background-color: $white;
    box-shadow: $sidebar-box-shadow;
    margin: 0 1rem;
    padding: 0.1rem 0.1rem;
    &-name {
      margin: auto;
    }
    &-size {
      margin: auto;
      color: $gray-light;
    }
    &-date {
      margin: auto;
      color: $gray-light;
    }
    &-buttons {
      display: flex;
      justify-content: flex-end;
    }
    &--undo {
      background: none;
      box-shadow: none;
    }
  }

</style>


// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-file-upload/VuesticFileUploadSingleItem.vue